module.exports = __webpack_public_path__ + "static/media/YM89_4.bfbdb150.jpg";